import { render, staticRenderFns } from "./campusfamilyPhone.vue?vue&type=template&id=a2b5a62a&scoped=true"
import script from "./campusfamilyPhone.vue?vue&type=script&lang=js"
export * from "./campusfamilyPhone.vue?vue&type=script&lang=js"
import style0 from "./campusfamilyPhone.vue?vue&type=style&index=0&id=a2b5a62a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b5a62a",
  null
  
)

export default component.exports